export const Colors={
    white:'#ffffff',
    black:'#000000',
    red:'#F05454',
    grey:'#DDDDDD',
    darkBlue:'#222831',
    blue1:'#25324A',
    blue2:'#30475E',
    blue3:'#1c1f2d',
    yellow:'#fcbe07',
    green:'#0DE396',
}

export const Fonts={
    roboto:'\'Roboto\', sans-serif',
    robotoSlab:"'Roboto Slab', serif",
}

export const mobileSize='700px';